export default __webpack_public_path__ + "static/media/Mystic's Delight.fa095c8e.jpg";